import { useAuthContext } from 'src/auth/useAuthContext';
import { openAppAsUser } from 'src/utils/user-utils';
import { useCollaborateBridgeListener } from './hooks';
import { MessagesTypes } from './types';

export const CollaborateNativeEventsHandler = () => {
  const { logout } = useAuthContext();

  useCollaborateBridgeListener(MessagesTypes.CHANGE_WORKSPACE, (data) => {
    openAppAsUser(data.payload.userId, true);
  });

  useCollaborateBridgeListener(MessagesTypes.LOGOUT, () => {
    logout();
  });

  return null;
};
